import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { RoleNavService } from '@core/auth/role-nav.service';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatMenuModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="bottom-nav" aria-label="Primary navigation">
      @for (item of items(); track item.route) {
        <a class="bottom-nav__link" [routerLink]="item.route" routerLinkActive="bottom-nav__link--active">
          <app-icon [name]="item.icon" [size]="20" />
          <span class="bottom-nav__label">{{ item.label }}</span>
        </a>
      }
      @if (more().length) {
        <button
          type="button"
          class="bottom-nav__link bottom-nav__more"
          [matMenuTriggerFor]="moreMenu"
          aria-label="More navigation options"
        >
          <app-icon name="menu" [size]="20" />
          <span class="bottom-nav__label">More</span>
        </button>
        <mat-menu #moreMenu="matMenu" yPosition="above" xPosition="before">
          @for (item of more(); track item.route) {
            <a mat-menu-item [routerLink]="item.route">
              <app-icon [name]="item.icon" [size]="18" />
              <span>{{ item.label }}</span>
            </a>
          }
        </mat-menu>
      }
    </nav>
  `,
  styleUrl: './bottom-nav.component.scss'
})
export class BottomNavComponent {
  private readonly nav = inject(RoleNavService);
  protected readonly items = computed(() => this.nav.bottomNav());
  protected readonly more = computed(() => this.nav.bottomNavMore());
}
